import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { createRef } from 'react';
import RadioInput from '@widgets/shared/components/form-controls/RadioInput';
import API from '@widgets/shared/API/connection';
import registerOrLoginAction from '@widgets/shared/registerOrLoginAction';
import { useState } from 'preact/compat';
import { Wrapper } from './styles';
function ChildrenForm(props) {
    const ref = createRef();
    const [isRequesting, setIsRequesting] = useState(false);
    const { successUrl, childrenTitle: title, childrenCopy: copy, loginChildren, onHandleError, childrenHeadingSize, password, username, useLocalSuccessUrl, loginAction: loginActionOverride, } = props;
    const form = useFormContext();
    const { formState: { isValid }, handleSubmit, getValues, setError, } = form;
    const handleSubmitEvent = () => {
        setIsRequesting(true);
        const formEl = ref.current;
        API.loginChild(username, password, getValues('contactId'))
            .then((res) => {
            registerOrLoginAction(res, formEl, () => { }, (errors) => {
                errors.forEach((error) => {
                    if (error.field) {
                        setError(error.field, { message: error.message }, { shouldFocus: true });
                    }
                });
                if (res.message) {
                    onHandleError(res.message);
                }
            }, successUrl, useLocalSuccessUrl, loginActionOverride);
        })
            .finally(() => {
            setIsRequesting(false);
        });
    };
    return (_jsx(Wrapper, { children: _jsxs("form", { method: "POST", ref: ref, onSubmit: handleSubmit(handleSubmitEvent), noValidate: true, className: "form form--login", children: [_jsxs("div", { className: "form__content content-block", children: [_jsx("h2", { className: childrenHeadingSize ?? 'h4', children: title ?? 'Please Log in' }), _jsx("span", { className: "p", children: copy ?? 'You have associated contacts linked to this account. Please select one to continue:' })] }), _jsx(RadioInput, { name: "contactId", type: "radio", labelAttrs: {
                        isFieldRequired: true,
                        text: 'Continue as',
                    }, options: loginChildren.map((child) => ({
                        label: `${child.Title} ${child.Forename} ${child.Surname}`,
                        value: `${child.ContactId}`,
                    })) }), _jsx("div", { className: "form__actions", children: _jsx("button", { type: "submit", className: "btn", disabled: !isValid || isRequesting, children: "Login" }) })] }) }));
}
export default ChildrenForm;
